import * as angular from "angular";
import {IController} from "angular";
import {AccountModel} from "../../angular/models/account.model";

export class SupplyAccountThreeplPreferencesComponent implements IController {

  account: AccountModel;
  preferences: any;
  onActiveChange: Function;

  constructor() {
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('supplyAccountThreeplPreferences', {
    bindings: {
      account: '<',
      preferences: '<',
      onActiveChange: '&'
    },
    template: require('./supply-account-threepl-preferences.html').default,
    controller: SupplyAccountThreeplPreferencesComponent
  });
